<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div class="layout-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-config></app-config>
    <!-- Fase 7 — aviso de llaves de acceso cuando la política las habilita -->
    <app-passkeys-intro></app-passkeys-intro>
    <div class="layout-mask"></div>
</div>

<div class="layout-banners">
<!-- Alerta de mantenimiento programado -->
<div
    *ngIf="showMaintenanceAlert"
    class="maintenance-banner"
>
    <div class="maintenance-banner__accent"></div>
    <div class="maintenance-banner__body">
        <div class="maintenance-banner__icon-wrap">
            <i class="pi pi-wrench"></i>
        </div>
        <div class="maintenance-banner__content">
            <span class="maintenance-banner__title">Mantenimiento programado</span>
            <p class="maintenance-banner__message">{{ maintenanceAlertMessage }}</p>
            <div *ngIf="maintenanceScheduledAt" class="maintenance-banner__date">
                <i class="pi pi-calendar-clock"></i>
                {{ maintenanceScheduledAt | date:'d MMM yyyy · h:mm a' }}
            </div>
        </div>
        <button class="maintenance-banner__close" (click)="showMaintenanceAlert = false" pRipple>
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<!-- Alerta de usuario trabajando fuera de su empresa base -->
<div
    *ngIf="showHomeCompanyAlert && homeCompanyStatus"
    class="maintenance-banner maintenance-banner--home-company"
>
    <div class="maintenance-banner__accent"></div>
    <div class="maintenance-banner__body">
        <div class="maintenance-banner__icon-wrap">
            <i class="pi pi-building"></i>
        </div>
        <div class="maintenance-banner__content">
            <span class="maintenance-banner__title">Fuera de tu empresa</span>
            <p class="maintenance-banner__message">
                Estás trabajando en <b>{{ homeCompanyStatus.currentCompanyName }}</b>, pero tu empresa es
                <b>{{ homeCompanyStatus.homeCompanyName }}</b>. Recuerda regresar a tu empresa.
            </p>
            <div class="maintenance-banner__actions">
                <button
                    pButton
                    type="button"
                    class="p-button-sm"
                    label="Regresar a mi empresa"
                    [loading]="isReturningHome"
                    (click)="returnToHomeCompany()"
                ></button>
                <button
                    pButton
                    type="button"
                    class="p-button-sm p-button-secondary p-button-outlined"
                    label="Cerrar sesión"
                    [disabled]="isReturningHome"
                    (click)="logoutFromHomeCompanyAlert()"
                ></button>
            </div>
        </div>
        <button class="maintenance-banner__close" (click)="dismissHomeCompanyAlert()" pRipple>
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>
</div>
